package gr.tech.pdfgenerator.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.base
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY_TN
import org.jetbrains.compose.web.css.*


/*
    GENERAL PDF STYLE
*/
val ElementToPrintStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White)
            .zIndex(99)
    }
}

val GeneralParagraphStyle = CssStyle {
    base {
        Modifier
            .color(Colors.Black)
            .fontFamily(FONT_FAMILY_TN)
            .fontSize(13.3.px)
            .lineHeight(1.25)
            .textAlign(TextAlign.Start)
            .fillMaxWidth()
            .margin(0.px)
    }
}

val GeneralDocumentDividerStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.Black)
            .borderTop(2.px, LineStyle.Solid, Colors.Black)
            .margin(topBottom = 4.px)
    }
}

val GeneralLogoSmallStyle = CssStyle {
    base {
        Modifier
            .width(200.px)
            .height(autoLength)
    }
}



/*
    PDF Status Styles
 */
val PDFStatusTextStyle = CssStyle {
    base {
        Modifier
            .margin(0.px)
            .color(Theme.DarkGreen.rgb)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.5.cssRem)
    }
}

val PDFLoadingSpinnerAnimation = Keyframes {
    0.percent {
        Modifier
            .rotate(0.deg)
    }
    100.percent {
        Modifier
            .rotate(360.deg)
    }
}

val PDFColumnOverlay = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .padding(16.px)
    }
}

val PDFBackButtonStyle = CssStyle {
    base {
        Modifier
            .noBorder()
            .borderRadius(4.px)
            .padding(
                leftRight = 16.px,
                topBottom = 8.px
            )
            .backgroundColor(Theme.DarkGreen.rgb)
            .color(Colors.White)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.25.cssRem)
    }
}

val SmallerItemParagraphStyle = CssStyle {
    base {
        Modifier
            .fontFamily("Times New Roman")
            .fontSize(13.3.px)
            .lineHeight(1.12)
    }
}

val BoldUnderline = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .textDecorationLine(TextDecorationLine.Underline)
    }
}

val BoldItalic = CssStyle {
    base {
        Modifier
            .fontWeight(FontWeight.Bold)
            .fontStyle(FontStyle.Italic)
    }
}



/* INSERT FIELD STYLES */
val insertedFieldStyle = CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .zIndex(2)
        //use top and left to move
}


/* PAGE BACKGROUNDS */
val backgroundStyle = CssStyle.base {
    Modifier
        .position(Position.Absolute)
        .top(0.px)
        .left(0.px)
        .width(100.percent)
        .height(100.percent)
        .objectFit(ObjectFit.Cover)
        .zIndex(1)
}

val pageStyle = CssStyle.base {
    Modifier
        .width(816.px) //exact width for format: a4
        .height(1056.px) //1344
        .border(1.px, LineStyle.Solid, Colors.Black)
        .position(Position.Relative)
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .overflow(Overflow.Hidden)

        // New additions to prevent the Matt side padding thing
        .padding(0.px)
        .margin(0.px)
}

// This was created because starting with T3 I am aiming to try to recreate the pages
// in custom HTML to save on PDF file size. The background images add a few bit of MBs,
// and toying with Adobe to create/blank out sections is just more rough, than if I were to manually make them.
fun Modifier.pageStyleLeftRightPadding(): Modifier {
      return this
        .padding(leftRight = 48.px)
}

fun Modifier.pageStyleTopBottomPadding(): Modifier {
    return this
        .padding(topBottom = 54.px)
}